import { render, staticRenderFns } from "./OriginalOrderRevisionHistory.vue?vue&type=template&id=1628b00d&scoped=true"
import script from "./OriginalOrderRevisionHistory.vue?vue&type=script&lang=js"
export * from "./OriginalOrderRevisionHistory.vue?vue&type=script&lang=js"
import style0 from "./OriginalOrderRevisionHistory.vue?vue&type=style&index=0&id=1628b00d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1628b00d",
  null
  
)

export default component.exports